import {
    SiAdobeacrobatreader,
    SiGoogledocs,
    SiInternetcomputer,
    SiMicrosoftexcel,
    SiMicrosoftoutlook,
    SiMicrosoftpowerpoint,
    SiMicrosoftword,
} from '@icons-pack/react-simple-icons';

import { PhotoIcon } from '@heroicons/react/24/outline';

interface IFileIconProps {
    fileNameOrURL: string;
}

const iconSize = 14;
const iconColour = 'white';

export const FileIcon: React.FC<IFileIconProps> = ({ fileNameOrURL }) => {
    const fileName = fileNameOrURL.toLocaleLowerCase();
    let fileType = '';

    if (fileName.includes('.docx') || fileName.includes('.doc') || fileName.includes('.docm')) {
        fileType = 'docx';
    } else if (fileName.includes('.pptx') || fileName.includes('.ppt') || fileName.includes('.pptm')) {
        fileType = 'pptx';
    } else if (
        fileName.includes('xlsx') ||
        fileName.includes('.xls') ||
        fileName.includes('.xlsm') ||
        fileName.includes('.csv')
    ) {
        fileType = 'xlsx';
    } else if (fileName.includes('.pdf')) {
        fileType = 'pdf';
    } else if (fileName.includes('.eml') || fileName.includes('.msg')) {
        fileType = 'eml';
    } else if (fileName.includes('.txt')) {
        fileType = 'txt';
    } else if (fileName.includes('.png') || fileName.includes('.jpg') || fileName.includes('.jpeg')) {
        fileType = 'image';
    } else if (fileName === 'https') {
        fileType = 'online';
    }

    return (
        <div className="relative inline-block top-1 pr-2 w-[20px]">
            {fileType === 'docx' && (
                <SiMicrosoftword
                    color={iconColour}
                    size={iconSize}
                    className="mb-[1px]"
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                />
            )}
            {fileType === 'pptx' && (
                <SiMicrosoftpowerpoint
                    color={iconColour}
                    size={iconSize}
                    className="mb-[1px]"
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                />
            )}
            {fileType === 'xlsx' && (
                <SiMicrosoftexcel
                    color={iconColour}
                    size={iconSize}
                    className="mb-[1px]"
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                />
            )}
            {fileType === 'pdf' && (
                <SiAdobeacrobatreader
                    color={iconColour}
                    size={iconSize}
                    className="mb-[1px]"
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                />
            )}
            {fileType === 'eml' && (
                <SiMicrosoftoutlook
                    color={iconColour}
                    size={iconSize}
                    className="mb-[1px]"
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                />
            )}
            {(fileType === 'txt' || fileType === '') && (
                <SiGoogledocs
                    color={iconColour}
                    size={iconSize}
                    className="mb-[1px]"
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                />
            )}
            {fileType === 'online' && (
                <SiInternetcomputer
                    color={iconColour}
                    size={iconSize}
                    className="mb-[1px]"
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                />
            )}
            {fileType === 'image' && <PhotoIcon color={iconColour} fontSize={iconSize} />}
        </div>
    );
};
